import { Box } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';


export const Header = muiStyled(Box)(({ }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));

export const CreateAssessmentsStyles = muiStyled(Box)(({ }) => ({
    flexGrow: 1,
    overflow: "auto",
    display: 'flex',
    flexDirection: "column",
    '.select-affiliation-placeholder': {
        fontSize: 30,
        marginTop: 20,
        marginLeft: 10
    }

    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
}));

export const TestTakersStyles = muiStyled(Box)(({ }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    overflow: "hidden",
    '.school-classes-table': {
        flexGrow: 1,
        overflow: "auto"
    }
}));